import { useEffect, useRef, useState } from "react";
import { useFilterStore } from "@/marketing/stores/useFilterStore";
import { Input } from "@/marketing/components/ui/input";
import { useDebounce } from "@/marketing/hooks/useDebounce";

export function EngRateFilter() {
  const engRateMin = useFilterStore((s) => s.filters.engRateMin);
  const setEngRateMin = useFilterStore((s) => s.setEngRateMin);
  const [localValue, setLocalValue] = useState(engRateMin?.toString() ?? "");
  const debouncedValue = useDebounce(localValue, 300);
  const isInitial = useRef(true);

  useEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }
    const num = parseFloat(debouncedValue);
    setEngRateMin(debouncedValue === "" || isNaN(num) ? null : num);
  }, [debouncedValue, setEngRateMin]);

  return (
    <Input
      type="number"
      step="0.1"
      min="0"
      max="100"
      placeholder="Min Eng. Rate %"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      className="tw-h-10 tw-w-[150px]"
    />
  );
}
